import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

function Layout({ currentUser, onLogoutSuccess }) {
  const location = useLocation();

  return (
    <div className="app-shell">
      <Sidebar currentPath={location.pathname} currentUser={currentUser} />
      <div className="app-main">
        <Header currentPath={location.pathname} currentUser={currentUser} onLogoutSuccess={onLogoutSuccess} />
        <main className="content-area">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;